import React, { useState } from "react";
import { Box, CircularProgress, InputAdornment, TextField, Typography } from "@mui/material";
import { MascaraCep } from "../../../utils/MascaraCep";
import { buscarCep } from "../../../utils/Endereco";
import { gradeSx, inputSx, labelSx } from "./EstilosFicha";

// Campos de endereço com preenchimento pelo CEP (ViaCEP).
// `endereco` segue ENDERECO_VAZIO; `onChange` recebe o objeto atualizado.
const CamposEndereco = ({ idPrefixo, endereco, onChange, disabled, erros = {} }) => {
    const [buscando, setBuscando] = useState(false);
    const [erroCep, setErroCep] = useState("");

    const alterar = (campo, valor) => onChange({ ...endereco, [campo]: valor });

    const alterarCep = async (valor) => {
        const cep = valor.replace(/\D/g, "").slice(0, 8);
        onChange({ ...endereco, cep });
        setErroCep("");
        if (cep.length !== 8) return;

        setBuscando(true);
        try {
            const encontrado = await buscarCep(cep);
            if (encontrado) {
                onChange({ ...endereco, cep, ...encontrado });
            } else {
                setErroCep("CEP não encontrado. Preencha o endereço manualmente.");
            }
        } catch (error) {
            setErroCep("Não foi possível consultar o CEP. Preencha o endereço manualmente.");
        } finally {
            setBuscando(false);
        }
    };

    const campo = (nome, label, props = {}) => (
        <Box>
            <Typography component="label" htmlFor={`${idPrefixo}-${nome}`} sx={labelSx}>{label}</Typography>
            <TextField
                id={`${idPrefixo}-${nome}`}
                value={endereco[nome]}
                onChange={(e) => alterar(nome, e.target.value)}
                size="small"
                fullWidth
                disabled={disabled}
                error={Boolean(erros[nome])}
                helperText={erros[nome]}
                sx={inputSx}
                {...props}
            />
        </Box>
    );

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Box sx={{ ...gradeSx(3), gridTemplateColumns: { xs: "1fr", md: "1fr 2fr 1fr" } }}>
                {campo("cep", "CEP", {
                    value: MascaraCep(endereco.cep),
                    onChange: (e) => alterarCep(e.target.value),
                    placeholder: "00000-000",
                    error: Boolean(erroCep || erros.cep),
                    helperText: erroCep || erros.cep,
                    slotProps: { input: { endAdornment: buscando ? <InputAdornment position="end"><CircularProgress size={16} /></InputAdornment> : null } },
                })}
                {campo("rua", "Logradouro", { placeholder: "Rua, avenida..." })}
                {campo("numero", "Número", { placeholder: "Ex.: 120" })}
            </Box>
            <Box sx={gradeSx(2)}>
                {campo("complemento", "Complemento (opcional)", { placeholder: "Sala, apartamento..." })}
                {campo("bairro", "Bairro")}
            </Box>
            <Box sx={{ ...gradeSx(2), gridTemplateColumns: { xs: "1fr", md: "3fr 1fr" } }}>
                {campo("cidade", "Cidade")}
                {campo("estado", "UF", { placeholder: "SP", slotProps: { htmlInput: { maxLength: 2 } }, onChange: (e) => alterar("estado", e.target.value.toUpperCase()) })}
            </Box>
        </Box>
    );
};

export default CamposEndereco;
